import { clsx } from "clsx"
import { type FC, useState } from "react"
import EasyCropper, {
  type CropperProps as EasyCropperProps
} from "react-easy-crop"

import styles from "./Cropper.module.css"

type CropperProps = Pick<
  EasyCropperProps,
  | "image"
  | "zoom"
  | "crop"
  | "aspect"
  | "onZoomChange"
  | "onCropChange"
  | "onCropAreaChange"
  | "initialCroppedAreaPixels"
>

export const Cropper: FC<CropperProps> = (props) => {
  const [ready, setReady] = useState(false)

  return (
    <EasyCropper
      {...props}
      disableAutomaticStylesInjection
      classes={{
        containerClassName: clsx(
          styles.cropperContainer,
          ready && styles.cropperReady
        ),
        cropAreaClassName: styles.cropArea,
        mediaClassName: styles.media
      }}
      onMediaLoaded={() => setReady(true)}
    />
  )
}
